import { render, staticRenderFns } from "./FormOrganizationAdmin.vue?vue&type=template&id=6b018232&"
import script from "./FormOrganizationAdmin.vue?vue&type=script&lang=js&"
export * from "./FormOrganizationAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports